import persistStore from './persistStore'

let sInstance = null;

class LoginPolicy {
    constructor() {
        console.log("LoginPolicy: constructor");   
    }

    // Want this class to be singleton
    static getInstance() {
        if (!sInstance) {
            // console.log('loginpolicy: Returning a new instance for loginpolicy');
            sInstance = new LoginPolicy();
        }

        
        // console.log('LoginPolicy: Returned an already created instance for LoginPolicy')
        return sInstance;
    }

    initWithLoginPolicy() {

        this.iPersistObjectName = 'loginPolicy';
        this.iPersistStore = persistStore;
        this.iPersistStore.createPersistObject(this.iPersistObjectName);

        this.iPersistObject = this.iPersistStore.getPersistObject(this.iPersistObjectName);

        // if the persistent object exists
        if (this.iPersistObject.iSessionID) {

            this.iSessionID = this.iPersistObject.iSessionID;
            this.iUserCategory = this.iPersistObject.iUserCategory;
            this.iNoOfStoriesRead = this.iPersistObject.iNoOfStoriesRead;
            this.iStoriesRead = this.iPersistObject.iStoriesRead;

            return;
        }

        // Need to create it if it doesn't exist

        this.iSessionID = require('uuid').v4();

        let lRand = Math.random();

        this.iUserCategory = 'c';
        this.iNoOfStoriesRead = 0;
        
        if (lRand <= 0.50) {
            this.iUserCategory = 'a';
        }

        /*
        if (lRand > 0.25 && lRand <= 0.50 ) {
            this.iUserCategory = 'b';
        }*/

        this.iPersistObject.iSessionID = this.iSessionID;
        this.iPersistObject.iUserCategory = this.iUserCategory;
        this.iPersistObject.iNoOfStoriesRead = 0;
        this.iPersistObject.iStoriesRead = '';

        // Store this user category in the persistStore
        this.iPersistStore.updatePersistObject(this.iPersistObjectName, this.iPersistObject);
    }

    resetLoginPolicy() {
        // console.log('LoginPolicy: resetting the settings');
        this.iPersistStore.deletePersistObject(this.iPersistObjectName);
        return;
    }

    isLoggedIn() {
        this.iPersistObject = this.iPersistStore.getPersistObject(this.iPersistObjectName);
        return this.iPersistObject.isLoggedIn || false;
    }

    setIsLoggedIn(aIsLoggedIn) {

        this.iPersistObject = this.iPersistStore.getPersistObject(this.iPersistObjectName);

        this.iPersistObject.isLoggedIn = aIsLoggedIn || false;

        // console.log('LoginPolicy: Updating the settings with' + JSON.stringify(this.iPersistObject));
        this.iPersistStore.updatePersistObject(this.iPersistObjectName, this.iPersistObject);
    }

    storyRead(aStoryID) {

        if (this.isLoggedIn()) {
            // Just we need not have to accumulate anything here.
            return;
        }

        this.iNoOfStoriesRead += 1;

        if (!this.iStoriesRead || this.iStoriesRead === '') {
            this.iStoriesRead = aStoryID;
        } else {
            if (this.iStoriesRead.indexOf(aStoryID) < 0) {
                this.iStoriesRead += ',' + aStoryID;
            }
        }

        this.iPersistObject = this.iPersistStore.getPersistObject(this.iPersistObjectName);

        this.iPersistObject.iNoOfStoriesRead = this.iNoOfStoriesRead;
        this.iPersistObject.iStoriesRead = this.iStoriesRead;
        // Store them in the persistent store

        // console.log('LoginPolicy: Updating the settings with' + JSON.stringify(this.iPersistObject));
        this.iPersistStore.updatePersistObject(this.iPersistObjectName, this.iPersistObject);
    }

    shouldShowMandatoryLogin() {

        if (this.isLoggedIn()) {
            return false;
        }

        this.iPersistObject = this.iPersistStore.getPersistObject(this.iPersistObjectName);

        this.iUserCategory =  this.iPersistObject.iUserCategory;
        this.iNoOfStoriesRead = this.iPersistObject.iNoOfStoriesRead;

        if (this.iUserCategory === 'a' && this.iNoOfStoriesRead >= 3) {
            return true;
        }

        if (this.iUserCategory === 'b' && this.iNoOfStoriesRead >= 3) {
            //this.iUserCategory === 'a';
            return true;
        }

        if (this.iUserCategory === 'c' && this.iNoOfStoriesRead >= 3) {
            return true;
        }

        return false;
    }

    getUserDetails() {
        this.iPersistStore = persistStore;
        this.iPersistObject = this.iPersistStore.getPersistObject(this.iPersistObjectName);
        return this.iPersistObject;
    }
};

let lInstance = LoginPolicy.getInstance();

export default lInstance;


// WEBPACK FOOTER //
// ./src/lib/policymanager/loginPolicy.js